module.exports = __webpack_public_path__ + "8289fd0de113a51b5cacc3131f3eeccd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/gauge.png
// module id = 3490
// module chunks = 0